<template>
	<div class="ui-array-text-list">
		<div class="ui-array-text-list__label">
			<div v-if="tip" class="ui-array-text-list__label--tip">
				<UiTip :message="tip.message"/>
			</div>
			{{ label }}
		</div>
		<div class="ui-array-text-list__container">
			<div v-for="(item, index) in modelProxy"
				:key="index"
				class="ui-array-text-list__container--item">
				<div class="ui-array-text-list__container--item__number">
					{{ index + 1 }}
				</div>
				<div class="ui-array-text-list__container--item__input">
					<UiInput
						:type="inputType"
						:placeholder="inputPlaceholder"
						:resize="true"
						:maxLength="maxLength"
						:size="inputSize"
						:readonly="readonly"
						:disabled="disabled"
						:limit-watcher-enabled="false"
						:error="getFieldError(index)"
						:model-value="getObjVal(index)"
						@emitValue="(val) => setObjVal(index, val)"
						@focus="$emit('focus')"
						@blur="$emit('blur')"
					/>
				</div>
				<div class="ui-array-text-list__container--item__actions">
					<UiButton
						v-if="(index + 1) > minItems && !isDisabled"
						type="secondary"
						prependIcon="delete-icon"
						@click="remove(index)"
					/>
				</div>
			</div>
		</div>
		<div v-if="showAddAction" class="ui-array-text-list__actions">
			<UiButton
				label="Добавить"
				type="secondary"
				prependIcon="add"
				@click="add"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name: "UiArrayTextList",
	model: {
		prop: 'value',
		event: 'change',
	},
	props: {
		value: {
			type: Array,
			required: true,
		},
		setValueHandler: {
			type: Function,
			default: (v, item) => {
				console.log(item)
				return v;
			},
		},
		getValueHandler: {
			type: Function,
			default: (v) => v,
		},
		addValueHandler: {
			type: Function,
			default: () => '',
		},
		label: {
			type: String,
			required: true,
		},
		inputType: {
			type: String,
			default: 'textarea',
		},
		inputPlaceholder: {
			type: String,
			default: 'Введите текст',
		},
		inputSize: {
			type: String,
		},
		maxLength: {
			type: Number,
			default: Infinity,
		},
		error: {
			type: [String, Boolean, Object],
			default: false,
		},
		readonly: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		minItems: {
			type: Number,
			required: true,
		},
		maxItems: {
			type: Number,
			required: true,
		},
		/**
     * Объект подсказки
     */
		tip: {
			type: Object,
			default: null,
		},
	},
	computed: {
		modelProxy: {
			get() {
				if (!this.value.length && this.minItems) {

					const temps = [];
					for (let i = 0; i < this.minItems; i++) {
						temps.push(
							this.addValueHandler()
						)
					}

					this.$emit('change', [...temps]);
				}

				return this.value;
			},
			set(value) {
				if (!value) {
					value = [];
				}
				this.$emit('change', [...value]);
			},
		},
		showAddAction() {
			return this.modelProxy.length < this.maxItems && !this.isDisabled
		},
		errorParsed() {
			if (!this.error) {
				return false;
			}
			return JSON.parse(this.error) || false;
		},
		isDisabled() {
			return this.disabled || this.readonly
		},
	},
	methods: {
		getFieldError(index) {
			const key = 'item-' + index;
			if (this.errorParsed[key]) {
				return this.errorParsed[key];
			}

			return "";
		},
		getObjVal(index) {
			const item = this.modelProxy[index];
			return this.getValueHandler(item)
		},
		setObjVal(index, val) {
			const item = this.modelProxy[index];
			this.modelProxy[index] = this.setValueHandler(val, item);

			this.$emit('change', [...this.modelProxy]);
		},
		add() {
			this.modelProxy.push(
				this.addValueHandler()
			);

			this.$emit('change', [...this.modelProxy]);
		},
		remove(index) {
			this.modelProxy.splice(index, 1);

			this.$emit('change', [...this.modelProxy]);
		},
	}
}
</script>